module.exports = __webpack_public_path__ + "static/img/nav2.c1b08ab9.svg";